(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clikea-protect-landing-v2"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-cp2-calculator]');
  const variantData = document.querySelector('#cp2-variants');
  if (!root || !variantData) return;
  const variants = JSON.parse(variantData.textContent);
  const range = root.querySelector('#cp2-range');
  const plans = Array.from(root.querySelectorAll('[data-cp2-plans] button'));
  const durations = Array.from(root.querySelectorAll('[data-cp2-duration] button'));
  const name = root.querySelector('[data-cp2-name]');
  const price = root.querySelector('[data-cp2-price]');
  const variantInput = root.querySelector('[data-cp2-variant]');
  const submit = root.querySelector('[data-cp2-submit]');
  let plan = 'Plus';
  let duration = '';

  const update = () => {
    const variant = variants.find((item) => item.option1 === plan && item.option2 === range.value && item.option3 === duration);
    if (!variant) {
      name.textContent = 'Completa los pasos';
      price.textContent = '--';
      submit.disabled = true;
      variantInput.value = '';
      return;
    }
    name.textContent = `Clikea Protect ${plan} · ${duration}`;
    price.textContent = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(Number(variant.price) / 100);
    variantInput.value = variant.id;
    submit.disabled = false;
  };

  const choose = (buttons, value, set) => {
    buttons.forEach((button) => button.classList.toggle('is-selected', button.dataset.value === value));
    set(value);
    update();
  };

  plans.forEach((button) => button.addEventListener('click', () => choose(plans, button.dataset.value, (value) => { plan = value; })));
  durations.forEach((button) => button.addEventListener('click', () => choose(durations, button.dataset.value, (value) => { duration = value; })));
  range.addEventListener('change', update);
  document.querySelectorAll('[data-plan-link]').forEach((link) => link.addEventListener('click', () => choose(plans, link.dataset.planLink, (value) => { plan = value; })));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clikea-protect-organizer"]) return;
  try {
    
(() => {
  const init = () => {
    const shell = document.querySelector('.page-shell');
    const main = shell?.querySelector('main');
    const hero = main?.querySelector('.hero');
    const heroTemplate = document.querySelector('#cp-organizer-hero-template');
    const pathTemplate = document.querySelector('#cp-organizer-path-template');
    if (!main || !hero || !heroTemplate || !pathTemplate || shell.dataset.organized === 'true') return;

    shell.dataset.organized = 'true';
    const guide = main.querySelector('.guide-section');
    const compare = main.querySelector('.compare-section');
    const plans = main.querySelector('.plans-section');
    const calculator = main.querySelector('.calculator-section');
    const cases = main.querySelector('.cases-section');
    const process = main.querySelector('.process-section');
    const portal = main.querySelector('.portal-section');
    const trust = main.querySelector('.trust-section');
    const faq = main.querySelector('.faq-section');
    const closing = main.querySelector('.final-cta')?.closest('.final-cta-wrap');

    hero.id = 'top';
    hero.classList.add('cp-organizer__hero');
    hero.replaceChildren(heroTemplate.content.cloneNode(true));
    if (guide) guide.id = 'guia';
    hero.insertAdjacentElement('afterend', pathTemplate.content.firstElementChild.cloneNode(true));

    [guide, compare, plans, calculator, cases, process, portal, trust, faq, closing]
      .filter(Boolean)
      .forEach((section) => main.append(section));

    const path = main.querySelector('.cp-organizer__path');
    const links = Array.from(path?.querySelectorAll('a') || []);
    const targets = links
      .map((link) => ({ link, target: document.querySelector(link.getAttribute('href')) }))
      .filter((item) => item.target);

    links[0]?.classList.add('is-active');
    if ('IntersectionObserver' in window && targets.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.remove('is-active'));
          targets.find((item) => item.target === entry.target)?.link.classList.add('is-active');
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0.01 });
      targets.forEach((item) => observer.observe(item.target));
    }

    const quote = main.querySelector('.cpc3');
    const variantData = document.querySelector('#cpc3-variants-data');
    if (!quote || !variantData) return;

    let variants = [];
    try { variants = JSON.parse(variantData.textContent); } catch (_) { return; }
    const range = quote.querySelector('#cpc3-range');
    const button = quote.querySelector('#cpc3-cart-btn');
    const variantInput = quote.querySelector('#cpc3-variant-id');
    if (!range || !button || !variantInput) return;

    const ranges = ['4k-10k', '10k-20k', '20k-40k', '40k-70k', '70k-140k'];
    const plansByIndex = ['B\u00e1sico', 'Plus', 'Pro'];
    const durationsByIndex = ['1 a\u00f1o', '2 a\u00f1os'];
    const money = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(value);

    const syncQuote = () => {
      const planButton = quote.querySelector('#cpc3-plans .cpc3__pill.active');
      const durationButton = quote.querySelector('#cpc3-durations .cpc3__dur-btn.active');
      const rangeIndex = Number(range.value);
      const planIndex = Number(planButton?.dataset.plan);
      const durationIndex = Number(durationButton?.dataset.duration) - 1;
      if (!Number.isInteger(rangeIndex) || !Number.isInteger(planIndex) || !Number.isInteger(durationIndex)) return;

      const variant = variants.find((item) => item.option1 === plansByIndex[planIndex] && item.option2 === ranges[rangeIndex] && item.option3 === durationsByIndex[durationIndex]);
      variantInput.value = variant?.id || '';
      button.disabled = !variant;
      if (!variant) return;

      const currentPrice = Number(variant.price) / 100;
      const oneYear = variants.find((item) => item.option1 === plansByIndex[planIndex] && item.option2 === ranges[rangeIndex] && item.option3 === '1 a\u00f1o');
      if (durationIndex === 0) {
        const oneYearPrice = quote.querySelector('#cpc3-price-val');
        if (oneYearPrice) oneYearPrice.textContent = money(currentPrice);
      } else {
        const finalPrice = quote.querySelector('#cpc3-final');
        const regularPrice = quote.querySelector('#cpc3-regular');
        const saving = quote.querySelector('#cpc3-saving');
        const regular = oneYear ? (Number(oneYear.price) / 100) * 2 : currentPrice;
        if (finalPrice) finalPrice.textContent = money(currentPrice);
        if (regularPrice) regularPrice.textContent = money(regular);
        if (saving) saving.textContent = `-${money(Math.max(0, regular - currentPrice))}`;
      }
    };

    range.addEventListener('change', () => window.setTimeout(syncQuote, 0));
    quote.querySelectorAll('#cpc3-plans button, #cpc3-durations button').forEach((item) => {
      item.addEventListener('click', () => window.setTimeout(syncQuote, 0));
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clikea-protect-product"]) return;
  try {
    
(() => {
  const section = document.querySelector('[data-clikea-protect-product]');
  if (!section || section.dataset.ready === 'true') return;
  section.dataset.ready = 'true';

  ['#clikea-snake-wrapper', 'shopify-agent'].forEach((selector) => {
    const overlay = document.querySelector(selector);
    if (overlay) overlay.style.setProperty('display', 'none', 'important');
  });

  const form = section.querySelector('.cpp__form');
  const variantInput = section.querySelector('[data-variant-input]');
  const variantsNode = section.querySelector('[data-variants]');
  if (!form || !variantInput || !variantsNode) return;

  const variants = JSON.parse(variantsNode.textContent || '[]');
  const optionButtons = Array.from(section.querySelectorAll('[data-option-index]'));
  const addButton = section.querySelector('[data-add-button]');
  const mobileButton = section.querySelector('[data-mobile-button]');
  const coverage = {
    'Básico': {
      description: 'Protección esencial para tu PC gamer.',
      features: ['Protección contra fallas eléctricas', 'Cobertura para componentes críticos', 'Soporte técnico básico']
    },
    'Plus': {
      description: 'Cobertura ampliada para tu equipo.',
      features: ['Todo lo incluido en Básico', 'Protección ante derrames accidentales', 'Atención técnica prioritaria']
    },
    'Pro': {
      description: 'El nivel más completo de Clikea Protect.',
      features: ['Todo lo incluido en Plus', 'Atención prioritaria 24/7', 'Servicio preventivo incluido']
    }
  };
  const initial = variants.find((variant) => String(variant.id) === String(variantInput.value)) || variants[0];
  const selection = initial ? [...initial.options] : [];
  const money = (value) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(Number(value) / 100);

  const updateCoverage = (plan) => {
    const content = coverage[plan] || coverage['Básico'];
    const title = section.querySelector('[data-plan-title]');
    const description = section.querySelector('[data-plan-description]');
    const caption = section.querySelector('[data-plan-caption]');
    if (title) title.textContent = plan;
    if (description) description.textContent = content.description;
    if (caption) caption.textContent = `Lo esencial del plan ${plan}`;
    Array.from(section.querySelectorAll('[data-benefit]')).forEach((item, index) => {
      item.textContent = content.features[index] || '';
    });
  };

  const sync = () => {
    const variant = variants.find((item) => item.options.every((value, index) => value === selection[index]));
    const available = Boolean(variant && variant.available);
    if (variant) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('[data-price]');
      const mobilePrice = section.querySelector('[data-mobile-price]');
      const mobilePlan = section.querySelector('[data-mobile-plan]');
      if (price) price.textContent = money(variant.price);
      if (mobilePrice) mobilePrice.textContent = money(variant.price);
      if (mobilePlan) mobilePlan.textContent = `${variant.option1} · ${variant.option3}`;
      updateCoverage(variant.option1);
    }
    const availability = section.querySelector('[data-availability]');
    if (availability) availability.textContent = available ? 'Listo para contratar' : 'Esta combinación no está disponible';
    [addButton, mobileButton].filter(Boolean).forEach((button) => { button.disabled = !available; });
  };

  optionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const index = Number(button.dataset.optionIndex);
      selection[index] = button.dataset.optionValue || '';
      optionButtons.filter((item) => Number(item.dataset.optionIndex) === index).forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      sync();
    });
  });

  const mainImage = section.querySelector('.cpp__main-image');
  Array.from(section.querySelectorAll('[data-gallery-source]')).forEach((button) => {
    button.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.gallerySource || mainImage.src;
      mainImage.alt = button.dataset.galleryAlt || mainImage.alt;
      section.querySelectorAll('[data-gallery-source]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
      });
    });
  });

  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
